import {
    setCookie,
    getCookie,
    sendEventToAnalytics
} from '../../helpers/common-helpers.js';
import l10n from '../../lang/locallang';
const CGSkills = (function () {
    return {
        openPopup() {
            const { preAssessment, postAssessment } = l10n.textTopicResultNotification;

            window.addEventListener('click', (e) => {
                const videoPlayer = e.target.closest('.js-video-popup');
                if (videoPlayer) {
                    e.preventDefault();
                    const videoURL = videoPlayer.getAttribute('data-video');
                    const size = videoPlayer.getAttribute('data-size');
                    const type = videoPlayer.getAttribute('data-type');
                    const skillTitle = videoPlayer.closest('.course-topic-row').querySelector('.skill-name').innerText;
                    const skillQuestion = videoPlayer.closest('.course-topic-row').getAttribute('data-question');
                    const topicID = videoPlayer.closest('.course-topic-row').getAttribute('data-id');
                    // add type to page url as get parameter
                    if (type) {
                        let url = new URL(window.location.href);
                        // clear all get parameters
                        url.search = '';
                        url.searchParams.set('type', type);
                        url.searchParams.set('topicID', topicID);
                        window.history.pushState({}, '', url);
                    }
                    this.getCFContentUrl(videoURL)
                        .then(videoURL => {
                            // make size for iframe
                            const popup = new vsPopupClass();
                            const popupElement = document.getElementById('videoPlayerPopup');
                            if(!popupElement) return;
                            popupElement.querySelector('iframe').src = videoURL;
                            const titleEl = popupElement.querySelector('.skill-title');
                            const questionEl = popupElement.querySelector('.skill-question');
                            const typeEl = popupElement.querySelector('.skill-type');
                            if(titleEl) titleEl.innerText = skillTitle;
                            if(questionEl) questionEl.innerText = skillQuestion;
                            if(typeEl) typeEl.innerText = type === 'pre' ? preAssessment : postAssessment;
                            if (size === '1024x653') {
                                popupElement.dataset.size = 'player-small';
                            } else {
                                popupElement.dataset.size = 'player-large';
                            }
                            const sidebar = popupElement.querySelector('.popup-sidebar');
                            if (type === 'tutorial') {
                                if(sidebar) sidebar.style.display = 'none';
                                CGSkillsStatusUpdate.updateStatus('uncompleted');
                            }
                            if (type === 'pre' || type === 'post') {
                                if(sidebar) sidebar.style.display = 'flex';
                            }
                            popup.open('videoPlayerPopup');

                            sendEventToAnalytics('view_lesson');
                        })
                        .catch(error => {
                            console.error(error);
                        });
                }
            });
        },

        /*
        * Buttons in notification popup with result
        * */
        notificationButtons() {
            window.addEventListener('click', (e) => {
                const buttonAgain = e.target.closest('#skill-button-again');
                const buttonTutorial = e.target.closest('#skill-button-tutorial');
                const buttonNext = e.target.closest('#skill-button-next');
                const url = new URL(window.location.href);
                const type = url.searchParams.get('type');
                const topicID = url.searchParams.get('topicID');
                // if completed parameter is exists
                const isCompleted = url.searchParams.get('completed');
                if (buttonAgain) {
                    this.runNext('post');
                }
                if (buttonTutorial) {
                    this.runNext('tutorial');
                }
                if (buttonNext) {
                    if (type === 'pre') {
                        if (isCompleted) {
                            this.runNext('tutorial');// "skill" if we need next skill, was edited
                        } else {
                            this.runNext('tutorial');
                            // change status to uncompleted
                            CGSkillsStatusUpdate.updateUncompleted('tutorial', topicID);
                        }
                    }
                    if (type === 'post') {
                        this.runNext('skill');
                    }
                }
            });
        },

        CGContentEvents() {
            const self = this;
            window.addEventListener('message', function (event) {
                switch (event.data) {
                    case 'onIQPass':
                        // if success answer
                        self.openPopupNotification('onIQPass');
                        let url = new URL(window.location.href);
                        url.searchParams.set('completed', 'true');
                        window.history.pushState({}, '', url);
                        CGSkillsStatusUpdate.updateStatus('passed');
                        break;
                    case 'onIQFail':
                        // if failed answer
                        self.openPopupNotification('onIQFail');
                        CGSkillsStatusUpdate.updateStatus('failed');
                        break;
                    case 'onComplete':
                        // if completed
                        self.runNext('post');
                        CGSkillsStatusUpdate.updateStatus('completed');
                        break;
                    default:

                        break;

                }
            });
        },

        iDontKnowButton() {
            window.addEventListener('click', (e) => {
                const iDontKnowButton = e.target.closest('.idk-button');
                if (iDontKnowButton) {
                    this.runNext('tutorial');
                    CGSkillsStatusUpdate.updateStatus('skip');
                }
            });
        },

        runNext(action) {
            const { preAssessment, postAssessment } = l10n.textTopicResultNotification;
            //get topicID from URL
            const urlParams = new URLSearchParams(window.location.search);
            const topicID = urlParams.get('topicID'); // get from URL topic ID
            const topicElement = document.querySelector(`.course-topic-row[data-id="${topicID}"]`);
            const popupElement = document.getElementById('videoPlayerPopup');
            const urlWBT = topicElement.dataset.wbt || false;
            let urlIA = topicElement.dataset.ia || false;
            let url = new URL(window.location.href);
            // close popup notification
            const popup = new vsPopupClass();
            if (document.getElementById('topicResultNotification') && document.getElementById('topicResultNotification').classList.contains('opened')) {
                popup.close('topicResultNotification');
            }
            switch (action) {
                case 'tutorial':
                    popupElement.querySelector('.popup-sidebar').style.display = 'none';
                    if (urlWBT) {
                        this.getCFContentUrl(urlWBT)
                            .then(urlWBT => {
                                popupElement.querySelector('iframe').src = urlWBT;
                                // change type to tutorial
                                url.searchParams.set('type', 'tutorial');
                                window.history.pushState({}, '', url);
                            })
                            .catch(error => {
                                console.error(error);
                            });
                    }
                    break;
                case 'post':
                    if (topicElement.querySelector('.td-pre').querySelector('i.__green')) {
                        // passed pre-assessment so need close popup
                        popup.close('videoPlayerPopup');
                        CGSkillsStatusUpdate.updateSkillStatus(topicID);
                    } else {
                        if (urlIA) {
                            popupElement.querySelector('.popup-sidebar').style.display = 'flex';
                            this.getCFContentUrl(urlIA)
                                .then(urlIA => {
                                    popupElement.querySelector('iframe').src = urlIA;
                                    // change type to tutorial
                                    url.searchParams.set('type', 'post');
                                    window.history.pushState({}, '', url);
                                    // update .skill-type text
                                    popupElement.querySelector('.skill-type').innerText = postAssessment;
                                })
                                .catch(error => {
                                    console.error(error);
                                });
                        }
                    }

                    break;
                case 'skill':
                    // take next topic
                    const nextTopicElement = topicElement.nextElementSibling;

                    // remove url parameter completed
                    window.history.pushState({}, '', url);
                    urlIA = nextTopicElement.dataset.ia || false;
                    if (nextTopicElement.querySelector('.td-pre').querySelector('span.course-status')) {
                        // if next topic is completed
                        nextTopicElement.querySelector('.td-post a').click();
                        return;
                    }
                    if (urlIA) {
                        popupElement.querySelector('.popup-sidebar').style.display = 'flex';
                        const skillTitle = nextTopicElement.querySelector('.skill-name').innerText;
                        const skillQuestion = nextTopicElement.getAttribute('data-question');
                        const skillType = nextTopicElement.getAttribute('data-type');
                        this.getCFContentUrl(urlIA)
                            .then(urlIA => {
                                popupElement.querySelector('iframe').src = urlIA;
                                popupElement.querySelector('.skill-title').innerText = skillTitle;
                                popupElement.querySelector('.skill-question').innerText = skillQuestion;
                                popupElement.querySelector('.skill-type').innerText = skillType === 'pre' ? preAssessment : postAssessment;
                                // change type to tutorial
                                url.searchParams.set('topicID', nextTopicElement.dataset.id);
                                url.searchParams.delete('completed');
                                url.searchParams.set('type', 'pre');
                                window.history.pushState({}, '', url);
                            })
                            .catch(error => {
                                console.error(error);
                            });
                    }
                    break;
                default:
                    break;
            }
        },

        getCFContentUrl(source) {
            return new Promise((resolve, reject) => {
                source = source + "/index.html";
                fetch(getAwsContentUrl, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'X-CSRF-Token': csrfToken
                    },
                    body: JSON.stringify({path: source}),
                })
                    .then(response => response.json())
                    .then(data => {
                        if (data.url) {
                            resolve(data.url);
                        } else {
                            resolve(false);
                        }
                    })
                    .catch((error) => {
                        console.error('Error:', error);
                        reject(error);
                    });
            });
        },

        openPopupNotification(type, topicID = null) {
            const { preAssessment, postAssessment, incorrect, correct } = l10n.textTopicResultNotification;
            const popup = document.getElementById('topicResultNotification');
            if (popup) {
                const popup = new vsPopupClass();
                const popupItem = document.getElementById('topicResultNotification');
                // get url parameter "type"
                const urlParams = new URLSearchParams(window.location.search);
                const skillType = urlParams.get('type'); // get from URL is it pre-, post- or tutorial test
                const topicID = urlParams.get('topicID'); // get from URL topic ID
                const topicElement = document.querySelector(`.course-topic-row[data-id="${topicID}"]`);
                if (skillType === 'pre') {
                    popupItem.querySelector('.skill-type').textContent = preAssessment;
                }
                if (skillType === 'post') {
                    popupItem.querySelector('.skill-type').textContent = postAssessment;
                }
                switch (type) {
                    case 'onIQFail':
                        if (skillType === 'pre') {
                            document.getElementById('skill-button-again').style.display = 'none';
                            document.getElementById('skill-button-tutorial').style.display = 'none';
                            document.getElementById('skill-button-next').style.display = 'block';
                        }
                        if (skillType === 'post') {
                            document.getElementById('skill-button-again').style.display = 'block';
                            document.getElementById('skill-button-tutorial').style.display = 'block';
                            document.getElementById('skill-button-next').style.display = 'none';
                        }
                        if (popupItem.querySelector('.result-icon').classList.contains('icon-correct')) {
                            popupItem.querySelector('.result-icon').classList.remove('icon-correct');
                            popupItem.querySelector('.result-icon').classList.add('icon-error');
                        }
                        popupItem.querySelector('.result-text').innerText = incorrect;
                        //popupItem.querySelector('.quick-answer-text').style.display = 'block';
                        popupItem.querySelector('.skill-type').innerText = skillType === 'pre' ? preAssessment : postAssessment;
                        break;
                    case 'onIQPass':
                        document.getElementById('skill-button-again').style.display = 'none';
                        document.getElementById('skill-button-tutorial').style.display = 'none';
                        if (skillType === 'pre') {
                            document.getElementById('skill-button-next').style.display = 'block';
                        } else {
                            document.getElementById('skill-button-next').style.display = 'none';
                        }
                        if (popupItem.querySelector('.result-icon').classList.contains('icon-error')) {
                            popupItem.querySelector('.result-icon').classList.remove('icon-error');
                            popupItem.querySelector('.result-icon').classList.add('icon-correct');
                        }
                        popupItem.querySelector('.result-text').innerText = correct;
                        popupItem.querySelector('.quick-answer-text').style.display = 'none';
                        break;
                    default:
                        break;
                }
                // set answer
                this.getCFContentAnswer(topicID)
                    .then(topicID => {
                        popupItem.querySelector('.quick-answer-text').style.display = 'block';
                        popupItem.querySelector('.quick-answer-response').innerHTML = topicID;
                    })
                    .catch(error => {
                        console.error(error);
                    });

                //create background div
                const background = document.createElement('div');
                background.classList.add('vs-popup-background', 'topicResultNotification-bg');
                // add background to body
                document.body.appendChild(background);
                // add popup to body
                popup.open('topicResultNotification');
            }
            this.closePopupNotification();
        },

        // event on close popup with notification
        closePopupNotification() {
            document.addEventListener('vsPopupAfterClose', (e) => {
                const popup = document.getElementById('topicResultNotification');
                popup.classList.remove('opened');
                if (popup) {
                    const background = document.querySelector('.topicResultNotification-bg');
                    if (background) {
                        background.remove();
                    }
                }
            });
        },

        getCFContentAnswer(topicID) {
            return new Promise((resolve, reject) => {
                fetch(getAnswerUrl, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({topic_id: topicID}),
                })
                    .then(response => response.json())
                    .then(data => {
                        if (data.response) {
                            // console.log(data.response)

                            resolve(data.response);
                        } else {
                            resolve(false);
                        }
                    })
                    .catch((error) => {
                        console.error('Error:', error);
                        reject(error);
                    });
            });
        }
    }
})();

const CGSkillsStatusUpdate = (
    function () {
        return {
            updateStatus(status) {
                console.log(status);
                // get status from URL
                const urlParams = new URLSearchParams(window.location.search);
                const type = urlParams.get('type'); // get from URL status
                const topicID = urlParams.get('topicID'); // get from URL topic ID
                switch (status) {
                    case 'failed':
                        this.updateFailed(type, topicID);
                        break;
                    case 'skip':
                        this.updateSkipped(type, topicID);
                        break;
                    case 'passed':
                        this.updatePassed(type, topicID);
                        break;
                    case 'uncompleted':
                        this.updateUncompleted(type, topicID);
                        break;
                    case 'completed':
                        this.updateCompleted(type, topicID);
                        console.log('completed');
                        break;
                    default:
                        break;
                }
            },
            updateSkipped(type, topicID) {
                const { skip, notStarted } = l10n.textTopicResultNotification;
                // add parameter to Cookies
                let cookieName = type + '_' + topicID;
                setCookie(cookieName, 'skip', 7);
                // update view
                let topicRow = document.querySelector('.course-topic-row[data-id="' + topicID + '"]');
                switch (type) {
                    case 'pre':
                        const tdPreElement = topicRow.querySelector('.td-pre');
                        if (tdPreElement.querySelector('a')) {
                            tdPreElement.querySelector('a').remove();
                        }
                        // create span instead of a
                        const spanPreElement = document.createElement('span');
                        spanPreElement.classList.add('course-status');
                        spanPreElement.innerHTML = `<i class="bullet __red"></i><span>${skip}</span>`;
                        tdPreElement.appendChild(spanPreElement);
                        // update tutorial to link
                        const tdTutorialElement = topicRow.querySelector('.td-tutorial');
                        if (tdTutorialElement.querySelector('span.course-status')) {
                            tdTutorialElement.querySelector('span.course-status').remove();
                            // create a instead of span
                            const aTutorialElement = document.createElement('a');
                            aTutorialElement.classList.add('course-status', 'js-video-popup');
                            aTutorialElement.href = '#';
                            aTutorialElement.dataset.type = 'tutorial';
                            aTutorialElement.dataset.video = tdTutorialElement.closest('.course-topic-row').dataset.wbt;
                            aTutorialElement.innerHTML = `<i class="bullet __gray"></i><span>${notStarted}</span>`;
                            tdTutorialElement.appendChild(aTutorialElement);
                        }
                        break;
                    case 'post':
                        const tdPostElement = topicRow.querySelector('.td-post');
                        if (tdPostElement.querySelector('span.course-status')) {
                            tdPostElement.querySelector('span.course-status').remove();
                            // create a instead of span
                            const aPostElement = document.createElement('a');
                            aPostElement.classList.add('course-status', 'js-video-popup');
                            aPostElement.href = '#';
                            aPostElement.dataset.type = 'post';
                            aPostElement.dataset.video = tdPostElement.closest('.course-topic-row').dataset.ia;
                            aPostElement.innerHTML = `<i class="bullet __red"></i><span>${skip}</span>`;
                            tdPostElement.appendChild(aPostElement);
                        }
                        if (tdPostElement.querySelector('a.course-status')) {
                            let aPostElement = tdPostElement.querySelector('a.course-status');
                            aPostElement.innerHTML = `<i class="bullet __red"></i><span>${skip}</span>`;
                        }
                        this.updateSkillStatus(topicID);
                        break;
                    default:
                        break;
                }
                this.updateUncompleted('tutorial', topicID);
            },
            updateFailed(type, topicID) {
                const { fail, notStarted } = l10n.textTopicResultNotification;
                // add parameter to Cookies
                let cookieName = type + '_' + topicID;
                setCookie(cookieName, 'fail', 7);
                // update view
                let topicRow = document.querySelector('.course-topic-row[data-id="' + topicID + '"]');
                switch (type) {
                    case 'pre':
                        const tdPreElement = topicRow.querySelector('.td-pre');
                        if (tdPreElement.querySelector('a')) {
                            tdPreElement.querySelector('a').remove();
                        }
                        // create span instead of a
                        const spanPreElement = document.createElement('span');
                        spanPreElement.classList.add('course-status');
                        spanPreElement.innerHTML = `<i class="bullet __red"></i><span>${fail}</span>`;
                        tdPreElement.appendChild(spanPreElement);
                        // update tutorial to link
                        const tdTutorialElement = topicRow.querySelector('.td-tutorial');
                        if (tdTutorialElement.querySelector('span.course-status')) {
                            tdTutorialElement.querySelector('span.course-status').remove();
                            // create a instead of span
                            const aTutorialElement = document.createElement('a');
                            aTutorialElement.classList.add('course-status', 'js-video-popup');
                            aTutorialElement.href = '#';
                            aTutorialElement.dataset.type = 'tutorial';
                            aTutorialElement.dataset.video = tdTutorialElement.closest('.course-topic-row').dataset.wbt;
                            aTutorialElement.innerHTML = `<i class="bullet __gray"></i><span>${notStarted}</span>`;
                            tdTutorialElement.appendChild(aTutorialElement);
                        }
                        break;
                    case 'post':
                        const tdPostElement = topicRow.querySelector('.td-post');
                        if (tdPostElement.querySelector('span.course-status')) {
                            tdPostElement.querySelector('span.course-status').remove();
                            // create a instead of span
                            const aPostElement = document.createElement('a');
                            aPostElement.classList.add('course-status', 'js-video-popup');
                            aPostElement.href = '#';
                            aPostElement.dataset.type = 'post';
                            aPostElement.dataset.video = tdPostElement.closest('.course-topic-row').dataset.ia;
                            aPostElement.innerHTML = `<i class="bullet __red"></i><span>${fail}</span>`;
                            tdPostElement.appendChild(aPostElement);
                        }
                        if (tdPostElement.querySelector('a.course-status')) {
                            let aPostElement = tdPostElement.querySelector('a.course-status');
                            aPostElement.innerHTML = `<i class="bullet __red"></i><span>${fail}</span>`;
                        }
                        this.updateSkillStatus(topicID);
                        break;
                    default:
                        break;
                }
            },
            updatePassed(type, topicID) {
                const { pass, notStarted } = l10n.textTopicResultNotification;
                // add parameter to Cookies
                let cookieName = type + '_' + topicID;
                setCookie(cookieName, 'pass', 7);
                // update view
                let topicRow = document.querySelector('.course-topic-row[data-id="' + topicID + '"]');
                const tdPostElement = topicRow.querySelector('.td-post');
                const tdPreElement = topicRow.querySelector('.td-pre');
                let aPostElement;
                let spanPreElement;
                switch (type) {
                    case 'pre':
                        if (tdPreElement.querySelector('a')) {
                            tdPreElement.querySelector('a').remove();
                        }
                        // create span instead of a
                        spanPreElement = document.createElement('span');
                        spanPreElement.classList.add('course-status');
                        spanPreElement.innerHTML = `<i class="bullet __green"></i><span>${pass}</span>`;
                        tdPreElement.appendChild(spanPreElement);
                        if (tdPostElement.querySelector('span.course-status')) {
                            tdPostElement.querySelector('span.course-status').innerHTML = `<i class="bullet __green"></i><span>(${pass})</span>`;
                        }
                        // update tutorial to link
                        const tdTutorialElement = topicRow.querySelector('.td-tutorial');
                        if (tdTutorialElement.querySelector('span.course-status')) {
                            tdTutorialElement.querySelector('span.course-status').remove();
                            // create a instead of span
                            const aTutorialElement = document.createElement('a');
                            aTutorialElement.classList.add('course-status', 'js-video-popup');
                            aTutorialElement.href = '#';
                            aTutorialElement.dataset.type = 'tutorial';
                            aTutorialElement.dataset.video = topicRow.dataset.wbt;
                            aTutorialElement.innerHTML = `<i class="bullet __gray"></i><span>${notStarted}</span>`;
                            tdTutorialElement.appendChild(aTutorialElement);
                        }
                        // set parameter to url completed
                        let url = new URL(window.location.href);
                        url.searchParams.set('completed', 'true');
                        window.history.pushState({}, '', url);
                        // update skill status
                        //this.updateSkillStatus(topicID);
                        break;
                    case 'post':
                        if (tdPostElement.querySelector('a')) {
                            let aPostElement = tdPostElement.querySelector('a');
                            aPostElement.querySelector('span').innerHTML = pass;
                            aPostElement.querySelector('i').removeAttribute('class');
                            aPostElement.querySelector('i').classList.add('bullet', '__green');
                        }
                        // if first level child is span
                        if (tdPostElement.querySelector('span.course-status')) {
                            tdPostElement.querySelector('span.course-status').remove();
                            // create a instead of span
                            aPostElement = document.createElement('a');
                            aPostElement.classList.add('course-status', 'js-video-popup');
                            aPostElement.href = '#';
                            aPostElement.dataset.type = 'tutorial';
                            aPostElement.dataset.video = tdPostElement.closest('.course-topic-row').dataset.wbt;
                            aPostElement.innerHTML = `<i class="bullet __green"></i><span>${pass}</span>`;
                            tdPostElement.appendChild(aPostElement);
                        }
                        if (tdPostElement.querySelector('a.course-status')) {
                            let aPostElement = tdPostElement.querySelector('a.course-status');
                            aPostElement.innerHTML = `<i class="bullet __green"></i><span>${pass}</span>`;
                        }
                        this.updateSkillStatus(topicID);
                        break;

                }
            },
            updateUncompleted(type, topicID) {
                const { incomplete} = l10n.textTopicResultNotification;
                // add parameter to Cookies
                let cookieName = type + '_' + topicID;
                let cookieValue = getCookie(cookieName);
                if (cookieValue === 'completed') {
                    return;
                }
                setCookie(cookieName, 'uncompleted', 7);
                let topicRow = document.querySelector('.course-topic-row[data-id="' + topicID + '"]');
                const tdTutorialElement = topicRow.querySelector('.td-tutorial');
                if (type === 'tutorial') {
                    if (tdTutorialElement.querySelector('a')) {
                        let aTutorialElement = tdTutorialElement.querySelector('a');
                        aTutorialElement.querySelector('span').innerHTML = incomplete;
                        aTutorialElement.querySelector('i').removeAttribute('class');
                        aTutorialElement.querySelector('i').classList.add('bullet', '__yellow');
                    } else {
                        if (tdTutorialElement.querySelector('span.course-status')) {
                            tdTutorialElement.querySelector('span.course-status').remove();
                        }
                        // create a instead of span
                        const aTutorialElement = document.createElement('a');
                        aTutorialElement.classList.add('course-status', 'js-video-popup');
                        aTutorialElement.href = '#';
                        aTutorialElement.dataset.type = 'tutorial';
                        aTutorialElement.dataset.video = tdTutorialElement.closest('.course-topic-row').dataset.wbt;
                        aTutorialElement.innerHTML = `<i class="bullet __yellow"></i><span>${incomplete}</span>`;
                        tdTutorialElement.appendChild(aTutorialElement);
                    }
                }
            },
            updateCompleted(type, topicID) {
                const { complete, pass, notStarted } = l10n.textTopicResultNotification;
                // add parameter to Cookies
                let cookieName = type + '_' + topicID;
                let aPostElement;
                setCookie(cookieName, 'completed', 7);
                let topicRow = document.querySelector('.course-topic-row[data-id="' + topicID + '"]');
                const tdTutorialElement = topicRow.querySelector('.td-tutorial');
                const tdPostElement = topicRow.querySelector('.td-post');
                if (type === 'tutorial') {
                    if (tdTutorialElement.querySelector('a')) {
                        let aTutorialElement = tdTutorialElement.querySelector('a');
                        aTutorialElement.querySelector('span').innerHTML = complete;
                        aTutorialElement.querySelector('i').removeAttribute('class');
                        aTutorialElement.querySelector('i').classList.add('bullet', '__green');
                    } else {
                        if (tdTutorialElement.querySelector('span.course-status')) {
                            tdTutorialElement.querySelector('span.course-status').remove();
                        }
                        // create a instead of span
                        const aTutorialElement = document.createElement('a');
                        aTutorialElement.classList.add('course-status', 'js-video-popup');
                        aTutorialElement.href = '#';
                        aTutorialElement.dataset.type = 'tutorial';
                        aTutorialElement.dataset.video = tdTutorialElement.closest('.course-topic-row').dataset.wbt;
                        aTutorialElement.innerHTML = `<i class="bullet __green"></i><span>${complete}</span>`;
                        tdTutorialElement.appendChild(aTutorialElement);
                    }
                    // update Post as well
                    if (tdPostElement.querySelector('span.course-status')) {
                        tdPostElement.querySelector('span.course-status').remove();
                        // create a instead of span
                        aPostElement = document.createElement('a');
                        aPostElement.classList.add('course-status', 'js-video-popup');
                        aPostElement.href = '#';
                        aPostElement.dataset.type = 'post';
                        aPostElement.dataset.video = tdPostElement.closest('.course-topic-row').dataset.ia;
                        // if cookie is set to completed
                        if (this.getCookie('pre_' + topicID) === 'pass') {
                            aPostElement.innerHTML = `<i class="bullet __green"></i><span>(${pass})</span>`;
                        } else {
                            aPostElement.innerHTML = `<i class="bullet __gray"></i><span>${notStarted}</span>`;
                        }

                        tdPostElement.appendChild(aPostElement);
                    }
                }
            },
            // if post is completed add class to skill row
            updateSkillStatus(topicID) {
                let topicRow = document.querySelector('.course-topic-row[data-id="' + topicID + '"]');
                topicRow.classList.add('__light-green-bg');
            },
            // Function to set a cookie
            setCookie(name, value, days) {
                let expires = "";

                if (days) {
                    let date = new Date();
                    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
                    expires = "; expires=" + date.toUTCString();
                }

                document.cookie = name + "=" + value + expires + "; path=/";
            },
            getCookie(cookieName) {
                let name = cookieName + "=";
                let decodedCookie = decodeURIComponent(document.cookie);
                let cookieArray = decodedCookie.split(';');

                for (let i = 0; i < cookieArray.length; i++) {
                    let cookie = cookieArray[i];
                    while (cookie.charAt(0) === ' ') {
                        cookie = cookie.substring(1);
                    }
                    if (cookie.indexOf(name) === 0) {
                        return cookie.substring(name.length, cookie.length);
                    }
                }

                return "";
            }
        }
    }
)();

const videoPlayerTutorial = (function () {
    return {
        init() {
            window.addEventListener('click', (e) => {
                const button = e.target.closest('.js-video-popup-alt');
                if (button) {
                    e.preventDefault();
                    const videoURL = button.getAttribute('data-video');
                    const size = button.getAttribute('data-size');
                    // make size for iframe

                    const popup = new vsPopupClass();

                    const popupElement = document.querySelector('#videoPlayerPopup');
                    const iframe = popupElement.querySelector('iframe');
                    this.getCFContentUrl(videoURL).then((url) => {
                        if (url) {

                            if (size === '1024x653') {
                                popupElement.dataset.size = 'player-small';
                            } else {
                                popupElement.dataset.size = 'player-large';
                            }
                            popup.open('videoPlayerPopup');
                            iframe.src = url;

                            sendEventToAnalytics('view_lesson');
                        }
                    });
                }
            });
        },
        getCFContentUrl(source) {
            return new Promise((resolve, reject) => {
                source = source + "/index.html";
                fetch(getAwsContentUrl, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'X-CSRF-Token': csrfToken
                    },

                    body: JSON.stringify({path: source}),
                })
                    .then(response => response.json())
                    .then(data => {
                        if (data.url) {
                            resolve(data.url);
                        } else {
                            resolve(false);
                        }
                    })
                    .catch((error) => {
                        console.error('Error:', error);
                        reject(error);
                    });
            });
        },
    }
})();

export {
    CGSkills,
    CGSkillsStatusUpdate,
    videoPlayerTutorial,
}
